const IS_PRODUCTION = process.env.ENVIRONMENT === 'production';

/** CDN URL for portal config: {CDN_BASE}/{prefix}/booking-portal/booking-portal-{group_id}.json */
export function getBookingPortalConfigUrl(groupId: string): string | null {
	try {
		const cdnBase = process.env.ATTACHMENTS_CDN_URL;
		let prefix = IS_PRODUCTION ? 'app' : process.env.ENVIRONMENT;
		try {
			prefix = process.env.ATTACHMENTS_CDN_PREFIX;
		} catch {
			// ignore
		}
		const resolvedPrefix = prefix ?? (IS_PRODUCTION ? 'app' : process.env.ENVIRONMENT);
		if (!cdnBase?.trim() || !groupId?.trim() || !resolvedPrefix?.trim()) {
			return null;
		}
		const base = cdnBase.replace(/\/+$/, '');
		return `${base}/${resolvedPrefix}/booking-portal/booking-portal-${groupId}.json`;
	} catch {
		return null;
	}
}
